<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle  :lang="lang.Middle"></Middle>
            <!-- <Right v-show="isVisibleRight" :lang="lang.Right"></Right> -->
 </div>
</template>

<script>
import Left from "@/components/ProjectManager/Views/ProjectNew/Left/Left";
import Middle from "@/components/ProjectManager/Views/ProjectNew/Middle/Middle";
// import Right from '@/components/ProjectManager/Views/ProjectNew/Right/Right'
import { mapGetters } from "vuex";

export default {
  name: "ProjectNew",
  components: {
    Left,
    Middle,
    // Right
  },
  data() {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    };
  },
  props: {
    routingData: Object,
    lang: Object
  },
  computed: {
    ...mapGetters(["isPlugin"])
  }
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectNew.vue